/*
  This store currently only stores a user's total ratings count under the key
  ratingsCount. Ideally, in the future it could hold more, for example a map of
  bookIDs to rating.

  As of right now, rating information for a specific book on the page is stored
  in ShelvingsStore. Eventually, we may move all rating information into this
  store.
*/
import _ from "lodash";
import Reflux from "reflux";
import Freezer from "freezer-js";
import ShelvingsActions from "../react_actions/shelvings_actions";

const defaultState = { ratingsCount: {} };
const state = new Freezer(defaultState);

const getState = function() {
  return state.get();
};

const resetTo = function(data) {
  getState().reset(_.merge({}, defaultState, data));
};

export default Reflux.createStore({
  listenables: [{ ratedNewBook: ShelvingsActions.rateBook.newBook },
                { rateBookFailed: ShelvingsActions.rateBook.failed }],
  getState,
  getInitialState: getState,

  initializeWith(data) {
    resetTo({
      ratingsCount: data.ratingsCount,
    });
  },

  onRatedNewBook() {
    const oldRatingsCount = getState().ratingsCount;
    this.trigger(getState().set("ratingsCount", oldRatingsCount + 1));
  },

  onRateBookFailed() {
    const oldRatingsCount = getState().ratingsCount;
    this.trigger(getState().set("ratingsCount", oldRatingsCount - 1));
  },

  reset() {
    resetTo({});
  },
});
